<div class="sidebar-outer">
  <a class="logo d-flex align-items-center">
    <!--<img src="assets\img\white-logo.png"style="height:42px;width:143px;" />-->
    <span class="start">Laurus</span>
    <!--<img src="assets/img/app/VechicleLogo.PNG" style="width:100px;margin-left: 41px;" />-->
  </a>
    <app-vertical-menu [menuItems]="menuItems"></app-vertical-menu>    
</div>
